// extracted by css-extract-rspack-plugin
var _1 = "J5ft5";
export { _1 as "skipToMainContentLink" }
